import { Component, OnInit ,Inject} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

export interface DialogData {
  data: any;  
}

@Component({
  selector: 'app-dialog-copy-pedido',
  templateUrl: './dialog-copy-pedido.component.html',
  styleUrls: ['./dialog-copy-pedido.component.scss']
})
export class DialogCopyPedidoComponent implements OnInit {

  constructor(    
    public dialogRef: MatDialogRef<DialogCopyPedidoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData 
  ){}

  public pedidos;
  ngOnInit() {
    this.pedidos = JSON.parse(this.data["infoPedido"]);

  }

}
